import PropTypes from 'prop-types'

import {
  Box,
  Icon,
  Dialog,
  Heading,
  Text,
  Button,
  Link,
} from '@redriverpress/system'

export default function VideoAccessDialog({
  onOpenChange,
  open,
  userLoggedIn,
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Overlay />
      <Dialog.StyledContent onPointerDownOutside={e => e.preventDefault()}>
        <Dialog.StyledTitle>
          <Heading as='h6' mb={0}>
            Subscribe now
          </Heading>
        </Dialog.StyledTitle>
        <Box py={3}>
          <Text>
            Get full access to all of our video content with a subscription
            to&nbsp;Ellii.
          </Text>
          {userLoggedIn && (
            <Box display='flex' justifyContent='center' mt={4} mb={3}>
              <Button as='a' href='/pricing'>
                <Icon icon='key-skeleton' pr={2} />
                Subscribe
              </Button>
            </Box>
          )}
          {!userLoggedIn && (
            <Box>
              <Box display='flex' justifyContent='center' mt={4} mb={3}>
                <Button as='a' href='/pricing'>
                  <Icon icon='plus' pr={2} />
                  Sign Up
                </Button>
              </Box>
              <Box textAlign='center'>
                <Text>
                  Already using Ellii?
                  <Link fontWeight={600} color='black' href='/sign_in' ml={1}>
                    Log in
                  </Link>
                </Text>
              </Box>
            </Box>
          )}
        </Box>
      </Dialog.StyledContent>
    </Dialog.Root>
  )
}

VideoAccessDialog.propTypes = {
  onOpenChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  userLoggedIn: PropTypes.bool.isRequired,
}
